import header from '../_modules/header/index.js'
import { revealLinksOnAction, setTimezone } from "../_modules/helpers";
import { handleRefsUs } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';

header()
revealLinksOnAction(() => {
    handleRefsUs()
    FirstTouchTracking()
})
setTimezone()